<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-account"
      icon-small
      title="لیست پس انداز ها"
      color="accent"
    >
      <template v-slot:topActons>
        <v-chip
          class="ma-2"
          color="success"
          outlined
        >
          <v-icon left>
            mdi-cash
          </v-icon>
          موجودی پس انداز: {{ totalSavedMoney.toString().toPriceFormat() }} ریال
        </v-chip>
      </template>
      <v-row v-if="!userSavedMonies || userSavedMonies.length == 0">
        <v-col cols="12">
          <div class="red--text text-h4 text-center">
            تاکنون پس اندازی برای شما ثبت نشده است.
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          md="12"
        >
          <v-data-table
            :headers="headers"
            :items="userSavedMonies"
            :items-per-page="500"
            class="elevation-1"
          >
            <template v-slot:item="row">
              <tr>
                <td class="text-center">
                  {{ row.item.amount.toString().toPriceFormat() }} ریال
                </td>
                <td class="text-right">
                  {{ row.item.description }}
                </td>
                <td class="text-center">
                  {{ row.item.saveDate_Persian.date }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'MemberLoansView',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
    },
    data () {
      return {
        totalSavedMoney: 0,
        localData: {},
        userSavedMonies: [],
        headers: [{
          text: 'مبلغ',
          align: 'center',
          sortable: true,
          value: 'amount',
        }, {
          text: 'توضیحات',
          align: 'right',
          sortable: true,
          value: 'description',
        }, {
          text: 'تاریخ ثبت',
          align: 'center',
          sortable: true,
          value: 'saveDate_Persian.date',
        },
        ],
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.activeTab = 0
        api.get('member/userSavedMoney/Get', null)
          .then(
            response => {
              this.userSavedMonies = response
              var sum = 0
              for (let index = 0; index < this.userSavedMonies.length; index++) {
                sum += this.userSavedMonies[index].amount
              }
              this.totalSavedMoney = sum
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
